export const comments_3278337 = {"data":{"data":[],"links":{}}}